import { Controller } from "@hotwired/stimulus";
import { formSubmitWithWaitForJobCompletion } from "../jobCompletion";
import * as Turbo from "@hotwired/turbo";
import { attachCancelButtonConfirmation } from "../helpers";
import { trackEvent } from "../../Features/Analytics";

export default class CreateController extends Controller {
    static targets = [
        "form",
        "submit"
    ];
    static values = {
        getJobUrl: String,
        poiDetailUrl: String
    }

    readonly formTarget!: HTMLElement;
    readonly submitTarget!: HTMLElement;

    readonly getJobUrlValue!: string;
    readonly poiDetailUrlValue!: string;

    connect() {
        formSubmitWithWaitForJobCompletion(
            $(this.formTarget),
            $(this.submitTarget),
            this.getJobUrlValue,
            () => {
                trackEvent('placeCreated');
                Turbo.clearCache();
                Turbo.visit(this.poiDetailUrlValue);
            }
        );

        attachCancelButtonConfirmation();
    }
}
